var map = {
	"./conditional-form/1.jpg": "49ed",
	"./kid-a/1.jpg": "9481",
	"./kid-a/2.jpg": "e97a",
	"./kid-a/3.jpg": "0af3",
	"./kid-a/4.jpg": "9f0c",
	"./nouveau-frissons/1.jpg": "ed8e",
	"./nouveau-frissons/3.jpg": "0b00",
	"./nouveau-frissons/4.jpg": "e425",
	"./platform-x/1.jpg": "0dd7",
	"./platform-x/2.jpg": "97f8",
	"./sly-fox/1.jpg": "7770",
	"./sly-fox/2.jpg": "c9b6",
	"./sly-fox/3.jpg": "6dfc",
	"./sly-fox/4.jpg": "fb14",
	"./sly-fox/5.jpg": "d519",
	"./sly-fox/6.jpg": "e59b",
	"./we-are-unicorn/1.jpg": "c069",
	"./we-are-unicorn/2.jpg": "aa9b",
	"./we-are-unicorn/3.jpg": "2dd3",
	"./we-are-unicorn/4.jpg": "eef1",
	"./we-are-unicorn/5.jpg": "5d6c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51cf";